export default __webpack_public_path__ + "static/media/totalCost.13f52d93.svg";